<div class="kr-exchange__header">
  <h4 class="kr-exchange__header-text">
    {{ wallet.name }} / {{ 'exchange.dialog.title' | translate }}
  </h4>

  <button
    class="kr-exchange__header-btn-close"
    data-testid="exchange_close_btn"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    [onlyIcon]="true"
    (click)="dialogRef.close()">
    <fu-icon iconName="close-square"></fu-icon>
  </button>
</div>

<form class="kr-exchange__body">
  <div class="kr-exchange__content">
    <!--    <nav class="kr-tabs">-->
    <!--      <div-->
    <!--        class="kr-tabs__tab"-->
    <!--        data-testid="exchange_tab_crypto_crypto"      -->
    <!--        [class.kr-tabs__tab_active]="tab === 'crypto-crypto'"-->
    <!--        (click)="setTab('crypto-crypto')"-->
    <!--        translate="exchange.dialog.cryptoCrypto"></div>-->

    <!--      <div-->
    <!--        class="kr-tabs__tab"-->
    <!--        data-testid="exchange_tab_crypto_fiat"      -->
    <!--        [class.kr-tabs__tab_active]="tab === 'crypto-fiat'"-->
    <!--        (click)="setTab('crypto-fiat')"-->
    <!--        translate="exchange.dialog.cryptoFiat"></div>-->
    <!--    </nav>-->

    @if (tab === 'crypto-crypto') {
      <kr-crypto-crypto-flow [wallet]="wallet" [wallets]="wallets()" />
    } @else {
      <kr-crypto-fiat-flow [wallet]="wallet" [wallets]="wallets()" />
    }
  </div>
</form>
